export default {
  //首页表头相关的翻译
  layout: {
    header: {
      acccountPoints: "账号点数",
      perPoints: "永久点数",
      clientDownload:"客户端下载",
      //套餐类型
      packageType: "套餐类型",
      //优质
      highQuality: "优质",
      // 服务条款
      FWTK:'服务条款',
      // 隐私政策
      YSZC:"隐私政策",
      nodata:"暂无数据",
      noValue:"无"
    },
    account:{
      package:"套餐",
      account:"账户",
      exit:"退出",
    },
    //菜单显示
    menu: {
      //工作空间
      workspace: "工作空间",
      //我的AI
      myAI: "我的AI",
      //定制音色
      customizedVoice: "定制音色",
      //定制聊天机器人
      customizedChatbot: "定制聊天机器人",
      //限时活动
      limitedTimeActivity: "限时活动",
      //协作
      cooperation: "协作",
      //团队
      team: "团队",
      //账号
      account: "账号",
      //账号中心
      accountCenter: "账号中心",
      //套餐
      package: "套餐",
      //账单
      bill: "账单",
      //点数消耗
      pointsConsumption: "点数消耗",
    },
  },
  //兑换码弹窗
  redeemDialog:{
    redeem:"兑换码",
    title:'输入兑换码',
    typeRedeemPlaceholder:'请输入兑换码',
    confirm: "确认",
    cancel: "取消",
  },
  // 团队
  team:{
    teamUse:'团队点数消耗',
    allpoints:"总点数",
    teampeple:"团队成员数",
    allpeple:"最大成员数",
    state:"状态",
    action:"操作",
    invite:"邀请",
    describe:"*邀请其他用户加入您的团队即可共享您的点数和套餐，让团队的每个成员都可以共享你的高级功能，助力团队协作"
  },
  //账号中心
  accountcenter: {
    //基本信息
    basicInformation: "基本信息",
    //用户名
    userName: "用户名",
    //用户ID
    userID: "用户ID",
    //点 数
    points: "点 数",
    //套餐内容
    packageContent: "套餐内容",
    expireTime: "到期时间",
    //第三方绑定
    thirdPartyBinding: "第三方绑定",
    //解绑
    unbundling: "解绑",
    //修改手机号
    changePhoneNumber: "修改手机号或邮箱",
    //手机号
    phoneNumber: "手机号",
    // 邮箱
    email: "邮箱",
    //验证码
    verificationCode: "验证码",
    //发送短信
    sendSMS: "发送短信",
    //修改密码
    changePassword: "修改密码",
    //新密码
    newPassword: "新密码",
    //确认密码
    confirmPassword: "确认密码",
    //确认修改
    confirmModification: "确认修改",
    // 图形验证码
    picyzm: "图形验证码",
  },
  //账单
  bill: {
    //当前计费周期
    currentBillingCycle: "当前计费周期",
    //按月
    monthly: "按月",
    //购买时间
    purchaseTime: "购买时间",
    //到期时间
    expirationTime: "到期时间",
    //订单历史记录
    orderHistory: "订单历史记录",
    //开始时间
    startTime: "开始时间",
    //选择日期
    selectDate: "选择日期",
    //结束时间
    endTime: "结束时间",
    //查询
    query: "查询",
    //计费周期
    billingCycle: "计费周期",
    //描述
    describe: "描述",
    //价格
    price: "价格",
    // 点数消耗
    PointConsumption: "点数消耗",
    // 点数消耗
    balance: "当前余额",
    // 信息
    infor: "信息",
    // 日期
    date: "日期",
  },
  //套餐
  package: {
    // 包年
    yearly: "包年",
    // 包月
    monthly: "包月",
    //充值点数
    topUpPoints: "充值永久点数",
    //请选择
    pleaseSelect: "请选择",
    //订阅
    subscribe: "购买",
    // 延期
    delay: "延期",
    // 升级
    upgrade: "升级",
    // 免费试用
    freeTrial: "免费试用",
    //套餐情况
    packageStatus: "套餐情况",
    paymentMethod: "支付方式",
    paymentAlipay: "支付宝",
    //已选择的套餐
    theSelectedOffer: "已选择的套餐",
    //支付方式
    paymentMethods: "支付方式",
    //确认
    confirm: "确认",
    //微信支付
    weChatPay: "微信支付",
    //支付宝支付
    alipayPayment: "支付宝支付",
    //信用卡
    creditCard: "信用卡",
    //其它支付方式
    otherPaymentMethods: "其它支付方式",
    //卡号
    cardNumber: "卡号",
    //有效期
    expirationDate: "有效期",
    //国家/地区
    countryRegion: "国家/地区",
    //邮编
    zip: "邮编",
    //返回
    cancel: "返回",
    contactUs:'联系我们',
    firstChargeDouble:'首充翻倍',
    sendPoint:'赠送',
  },
  myAi: {
    delete: '删除',
    robotStatus: '机器人状态',
    done: '已完成',
    generating: '生成中',
    abnormal: '异常',
  },
  custom: {
    videoCustomizationDisplay: '视频定制展示',
    customizationInstructions: '定制须知',
    UploadRecordingInstructions: '上传录音说明',
    uploadInstructions: '上传须知',
    clickToAddAudio: '点击添加音频',
    clickVerificationAudio: '点击上传身份核实音频',
    clickToUploadIdentityVerificationAudio: '点击上传身份核实音频',
    recordingMandarin: '录音时长为10-15秒，使用普通话进行录制',
    confirmClearly: '*为了确认您的身份，请您提供一段本人的录音，清晰朗读以下文案',
    confirmText: '我确认购买定制服务并上传的素材，包括形象和声音，均为我本人，并且我对创作内容负有责任。我承诺不会创作任何违法内容。',
    DZXZTip1: '1.为了确保最终定制效果与您上传的原音频在音色、风格和韵律等方面基本一致，请确保您上传的原音频状态符合您个人的理想要求。',
    DZXZTip2: '2.在您提交订单后，为了确保定制效果的高质量，我们将对您上传的音频进行审核。如果您上传的音频不符合定制要求，您将在“我的AI”看到异常，并需要按照我们的要求重新上传。',
    DZXZTip3: '3.一旦审核通过，定制流程将开始进行。我们预计整个定制过程将在3个工作日内完成，请您耐心等待。',
    DZXZTip4: '4.定制完成后，您将获得该定制音色的一年使用权。使用权到期后，您可以选择以299元/年的价格进行续费。',
    DZXZTip5: '5.您在使用音色包时，需要消耗点数来补充额度。',
    DZXZTip6: '6.感谢您选择我们的定制服务，如果您有任何疑问或需要进一步的帮助，请随时联系我们。',
    SCXZTip1: '1. 请您上传一段本人的录音来确认您的身份，录音中请清晰的朗读出下列文案。',
    SCXZTip2: '2.朗读文案：我购买定制服务所上传的素材，形象及声音均是我本人，且对创作内容负责，不会创作违法内容。',
    SCXZRTip1: '1. 录音时长为10-15秒，使用普通话进行录制。',
    SCXZRTip2: '2. 音频中不应包含其他语言、方言，尽量避免包含英文单词或字母',
    SCXZRTip3: '3. 录音应自然流畅，停顿和节奏要自然。在表达情感时，请确保不过分夸张。',
    SCXZRTip4: '4. 发音应清晰准确，尽量避免错误读音、口误和杂音。',
    SCXZRTip5: '5. 所有录音必须由同一人进行，不得混入其他人的声音。',
    SCXZRTip6: '6. 为确保录音效果，请使用带有麦克风功能的高性能手机或录音设备进行录制。',
    SCXZRTip7: '7.请在安静的环境中录音，使用普通话录制，并且建议以48kHz的采样率保存为.wav格式的音频文件。',
    SCXZRTip8: '请保障音频满足一下要求：',
    cancel: '取 消',
    addVoice: '添加 语音',
    dialogCon:"我特此确认，我拥有上传和克隆这些语音样本的所有必要权利或同意，并且我不会将平台生成的内容用于任何非法、欺诈或有害目的。我重申我有义务遵守 意声达AI 的服务条款和隐私政策。",
    approval:'please select approval',
  },
  form: {
    setRobotName: '设置机器人名称',
    setGender:"性别",
    man:"男",
    fell:"女",
    setlang:"语言",
    zh:"中文",
    en:"英文",
    basicPrompt: '描述',
    describe: "描述",
    domainName: "域名",
    uploadFile: "点击上传文件",
    uploadFile1: "上传文件",
    uploadWebsite: "上传网站",
    basicSettings: '基础设置',
    embedDataSettings: '嵌入数据设置',
    chatInterface: '聊天界面',
    WebsiteEmbeddingSettings: '网站嵌入设置',
    ApplicableWhenEmbeddingWebsites: '嵌入网站时适用',
    reset: '重置',
    InitiatingMessage: '初始消息',
    SuggestMessage: '建议留言',
    theme: '主题',
    UpdateChatbotPicture: '更新聊天机器人个人资料图片',
    selectFile: '选择文件',
    DeleteChatbotPicture: '删除聊天机器人个人资料图片',
    name: '显示名称',
    UserMessageColor: '用户留言颜色',
    tip: '**如果此处的更改没有立即显示在您的网站上，请尝试清除浏览器缓存或使用隐身模式。 （新用户将立即看到更改）**',
    tip1: "在新行中输入每个域",
    tip2: "您想要嵌入聊天机器人的域。您的聊天机器人可见性必须是“公开”或“私有”，但可以嵌入到网站上“才能发挥作用”。<",
    enterUrl: '输入网址',
    getMoreConnections: '获取更多连接',
    OtherLinks: '其他链接',
    createNow: '立即创建',
    chatinput:"请输入内容",
    chatreply:"您好，请问有什么可以帮您？",
    userreply:"给我点一杯草莓牛乳啵啵"
  },
  loginPhone: {
    title: "知识产权总标题",
    subtitle: "在出版和平面设计中，Lorem ipsum是一种占位符文本，通常用于展示视觉效果。",
    formTitle: "验证手机",
    formSubTitle: "您已从Gmail重定向登录，请输入您的手机号进行验证。",
    resetCode: "重新发送",
    enterCode: "请输入验证码",
    Verify: "验证",
  },
  resetPassword: {
    title: '重置密码',
    toLogin: '去登录',
    toRegistry:"去注册",
    pleaseEnter: '请输入注册的手机号，以便我们验证并发送验证码',
    enterTheCode: '输入图片中的验证码',
    sendCode: '发送验证码',
    passWord: '请输入密码',
    passWordZZ:"密码至少为8位数,且必须为字母、数字、特殊字符中的两种或两种以上组合",
    angpassword:"请输入二次密码",
    recommendCode:"(选填)请输入邀请码",
    twopasswordNotSame:"两次输入密码不一致!",
    verify: '确认密码',
    verifyCode: '请输入验证码',
    phoneInput:'请输入手机号',
    phoneInputByZZ:"手机号格式不正确!",
    mailInput:'请输入邮箱',
    mailInputByZZ:"邮箱格式不正确!",
    usernameInput:"请输入手机号或者邮箱",
    imgVerifyCode: '请输入图片验证码',
    imgVerifyCodeByZZ:"图形验证码格式不正确!",
    registry:'注册',
    login:"登录",
    forgetpassword:"忘记密码",
    noaccout:"还没有账号",
    loginbyaccout:"账号密码登录",
    loginbyphone:"验证码登录",
    otherlogin:"第三方登录"
  },
};
